"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

export default function BackToHomeButton() {
  const pathname = usePathname();
  if (
    pathname === "/" ||
    pathname?.startsWith("/choose-username") ||
    pathname?.startsWith("/login")
  ) {
    return null;
  }

  const isDealPage = pathname?.startsWith("/deals/");
  const isOpportunityInbox =
    pathname === "/admin/price-opportunities" || pathname === "/admin/price-opportunities/";

  return (
    <Link
      href="/"
      className={`${isDealPage || isOpportunityInbox ? "ml-4 mt-4 md:fixed md:left-4 md:top-4 md:m-0" : "fixed left-4 top-4"} z-40 inline-flex items-center gap-2 rounded-full border border-mist bg-white/95 px-3 py-1.5 text-sm font-semibold text-ink shadow-sm transition hover:bg-mist/60`}
    >
      ← Volver al inicio
    </Link>
  );
}
